import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react";
import type { ReactNode } from "react";
import { ErrorFallback } from "./error-fallback";

type ErrorBoundaryProps = {
  children: ReactNode;
};

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
  return (
    <SentryErrorBoundary
      fallback={({ error, componentStack }) => (
        <ErrorFallback
          componentStack={componentStack}
          error={error instanceof Error ? error : new Error(String(error))}
          scope="application"
        />
      )}
    >
      {children}
    </SentryErrorBoundary>
  );
}
